import styled from 'styled-components';
import { color, themeGet } from '@magalu/stereo-ui-styles';
import { typography } from 'styled-system';
import LinkComp from '../../atoms/Link';
export const LinksList = styled.ul`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: ${themeGet('space.3')}px;
  margin-right: 8px;
`;
export const LinkItem = styled.li`
  list-style: none;
`; // Apply the same style to header's links and texts

const baseTextAttrs = {
  color: 'text.greyishBlue',
  fontSize: [0, 0, 0, 1],
  fontWeight: ['bold', 'bold', 'bold', 'regular']
};
export const Link = styled(LinkComp).attrs(props => Object.assign({
  p: 0
}, baseTextAttrs, props))`
  ${color}
  ${typography}
`;
export const TextLabel = styled.span.attrs(props => Object.assign({}, baseTextAttrs, props))`
  ${color}
  ${typography}
`;